module.exports = __webpack_public_path__ + "img/list1.4a618238.png";